import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import TreeView from '@material-ui/lab/TreeView';
import TreeItem from '@material-ui/lab/TreeItem';
import Typography from '@material-ui/core/Typography';
import LanguageIcon from '@material-ui/icons/Language';
import MapIcon from '@material-ui/icons/Map';
import MonetizationOnIcon from '@material-ui/icons/MonetizationOn';
import ApartmentIcon from '@material-ui/icons/Apartment';
import AssignmentIndIcon from '@material-ui/icons/AssignmentInd';
import BusinessIcon from '@material-ui/icons/Business';
import FeaturedPlayListIcon from '@material-ui/icons/FeaturedPlayList';
import PeopleAltIcon from '@material-ui/icons/PeopleAlt';
import AddShoppingCartIcon from '@material-ui/icons/AddShoppingCart';
import GroupWorkIcon from '@material-ui/icons/GroupWork';
import PermContactCalendarIcon from '@material-ui/icons/PermContactCalendar';
import FormatListNumberedRtlOutlinedIcon from '@material-ui/icons/FormatListNumberedRtlOutlined';
import DirectionsWalkIcon from '@material-ui/icons/DirectionsWalk';
import AccessibilityIcon from '@material-ui/icons/Accessibility';
import BusinessSharpIcon from '@material-ui/icons/BusinessSharp';
import EmailIcon from '@material-ui/icons/Email';
import AccountBalanceRoundedIcon from '@material-ui/icons/AccountBalanceRounded';
import AspectRatioIcon from '@material-ui/icons/AspectRatio';


const useTreeItemStyles = makeStyles((theme) => ({
  root: {
    color: theme.palette.text.secondary,
    '&:hover > $content': {
      backgroundColor: theme.palette.action.hover,
    },
    '&:focus > $content, &$selected > $content': {
      backgroundColor: `var(--tree-view-bg-color, ${theme.palette.grey[400]})`,
      color: 'var(--tree-view-color)',
    },
    '&:focus > $content $label, &:hover > $content $label, &$selected > $content $label': {
      backgroundColor: 'transparent',
    },
  },
  content: {
    color: theme.palette.text.secondary,
    borderTopRightRadius: theme.spacing(2),
    borderBottomRightRadius: theme.spacing(2),
    paddingRight: theme.spacing(1),
    fontWeight: theme.typography.fontWeightMedium,
    '$expanded > &': {
      fontWeight: theme.typography.fontWeightRegular,
    },
  },
  group: {
    marginLeft: 0,
    '& $content': {
      paddingLeft: theme.spacing(2),
    },
  },
  expanded: {},
  selected: {},
  label: {
    fontWeight: 'inherit',
    color: 'inherit',
  },
  labelRoot: {
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(0.5, 0),
  },
  labelIcon: {
    marginRight: theme.spacing(1),
  },
  labelText: {
    fontWeight: 'inherit',
    flexGrow: 1,
  },
}));

function StyledTreeItem(props) {
  const classes = useTreeItemStyles();
  const { labelText, labelIcon: LabelIcon, labelInfo, color, bgColor, ...other } = props;

  return (
    <TreeItem
      label={
        <div className={classes.labelRoot}>
          <LabelIcon color="inherit" className={classes.labelIcon} />
          <Typography variant="body2" className={classes.labelText}>
            {labelText}
          </Typography>
          <Typography variant="caption" color="inherit">
            {labelInfo}
          </Typography>
        </div>
      }
      style={{
        '--tree-view-color': color,
        '--tree-view-bg-color': bgColor,
      }}
      classes={{
        root: classes.root,
        content: classes.content,
        expanded: classes.expanded,
        selected: classes.selected,
        group: classes.group,
        label: classes.label,
      }}
      {...other}
    />
  );
}

StyledTreeItem.propTypes = {
  bgColor: PropTypes.string,
  color: PropTypes.string,
  labelIcon: PropTypes.elementType.isRequired,
  labelInfo: PropTypes.string,
  labelText: PropTypes.string.isRequired,
};

const useStyles = makeStyles({
  root: {
    height: 264,
    flexGrow: 1,
    maxWidth: 400,
  },
});

export default function GmailTreeView(props) {
  //const [Label,setLabel] = useState('');
  const classes = useStyles();

  const onLabelClick = (e) => {
    //setLabel(e.currentTarget.outerText);
    if (e.currentTarget.outerText === "Lead Source") {
      props.setName('LeadSource');
    }
    else if (e.currentTarget.outerText === "User Type") {
      props.setName('UserType');
    }
    // else if(e.currentTarget.outerText === "Service Centre"){
    //   props.setName('ServiceCentre');
    // }
    else {
      props.setName(e.currentTarget.outerText);
    }
  }
  // const onLabelClick1 = (e) => {
  //   //setLabel(e.currentTarget.outerText);
  //   if(e.currentTarget.outerText === "Service Centre'"){
  //     props.setName('ServiceCentre');
  //   }
  //   else{
  //     props.setName(e.currentTarget.outerText);
  //   }
  // }

  return (
    <TreeView
      className={classes.root}
      defaultEndIcon={<div style={{ width: 24 }} />}
    >
      <StyledTreeItem nodeId="1" labelText="Category" labelIcon={FormatListNumberedRtlOutlinedIcon} onLabelClick={(e) => onLabelClick(e)} />
      <StyledTreeItem nodeId="2" labelText="Mode Of Travel" labelIcon={LanguageIcon} onLabelClick={(e) => onLabelClick(e)} />
      <StyledTreeItem nodeId="3" labelText="Hotel Star Rating" labelIcon={ApartmentIcon} onLabelClick={(e) => onLabelClick(e)} />
      <StyledTreeItem nodeId="4" labelText="Currency" labelIcon={MonetizationOnIcon} onLabelClick={(e) => onLabelClick(e)} />
      <StyledTreeItem nodeId="5" labelText="Expense Type" labelIcon={AspectRatioIcon} onLabelClick={(e) => onLabelClick(e)} />
      <StyledTreeItem nodeId="6" labelText="Travelling Policy" labelIcon={DirectionsWalkIcon} onLabelClick={(e) => onLabelClick(e)} />
      <StyledTreeItem nodeId="7" labelText="Hotel Stay Policy" labelIcon={BusinessSharpIcon} onLabelClick={(e) => onLabelClick(e)} />
      <StyledTreeItem nodeId="8" labelText="DA Policy" labelIcon={PermContactCalendarIcon} onLabelClick={(e) => onLabelClick(e)} />
      {/* <StyledTreeItem nodeId="8" labelText="Spares Master" labelIcon={FeaturedPlayListIcon} onLabelClick={(e) => onLabelClick(e)} />
      <StyledTreeItem nodeId="9" labelText="Symptom Master" labelIcon={PeopleAltIcon} onLabelClick={(e) => onLabelClick(e)} />
      <StyledTreeItem nodeId="10" labelText="Reason Master" labelIcon={AddShoppingCartIcon} onLabelClick={(e) => onLabelClick(e)} />
      <StyledTreeItem nodeId="11" labelText="Defects Master" labelIcon={GroupWorkIcon} onLabelClick={(e) => onLabelClick(e)} />
      <StyledTreeItem nodeId="12" labelText="Repair Master" labelIcon={PermContactCalendarIcon} onLabelClick={(e) => onLabelClick(e)} />
      <StyledTreeItem nodeId="13" labelText="States Master" labelIcon={FormatListNumberedRtlOutlinedIcon} onLabelClick={(e) => onLabelClick(e)} />
      <StyledTreeItem nodeId="14" labelText="City/Area Master" labelIcon={DirectionsWalkIcon} onLabelClick={(e) => onLabelClick(e)} />
      <StyledTreeItem nodeId="15" labelText="User Master" labelIcon={AccessibilityIcon} onLabelClick={(e) => onLabelClick(e)} />
      <StyledTreeItem nodeId="16" labelText="Help Desk" labelIcon={EmailIcon} onLabelClick={(e) => onLabelClick(e)} />
      <StyledTreeItem nodeId="17" labelText="Parameter Configuration" labelIcon={AccountBalanceRoundedIcon} onLabelClick={(e) => onLabelClick(e)} />
      <StyledTreeItem nodeId="18" labelText="Questionnaire Master" labelIcon={AspectRatioIcon} onLabelClick={(e) => onLabelClick(e)}/>
      <StyledTreeItem nodeId="19" labelText="Service Charge" labelIcon={AspectRatioIcon} onLabelClick={(e) => onLabelClick(e)}/> */}
    </TreeView>
  );
}

